import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Image from '@base/FutureImage';
import H5 from '@base/H5/H5';
import P1 from '@base/P1/P1';

const NoResultFound = styled.div`
  display: block;
  text-align: center;
  width: 100%;
  padding: ${Spacings.SPACING_8B};
  background-color: var(--color-base-1);
  > p {
    color: var(--color-text-secondary);
    margin-top: ${Spacings.SPACING_2B};
  }
`;

const NoResultImage = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  display: inline-block;
  margin-bottom: ${Spacings.SPACING_5B};
`;

const NoResultFoundComponent = ({ heading, subHeading }) => {
  return (
    <NoResultFound>
      <NoResultImage>
        <Image
          src="zero-result.svg"
          alt="No Result Found"
          // layout="fill"
          width={80}
          height={80}
        />
      </NoResultImage>
      <H5>{heading || 'No goals found'}</H5>
      <P1>
        {subHeading ||
          'Try searching for your target exam e.g. ‘bank exams’ or ‘cbse class 10’'}
      </P1>
    </NoResultFound>
  );
};

export default NoResultFoundComponent;
